import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import _ from 'underscore'

import styles from './article-preview.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'



export default ({ article }) => (
  <Link to={`/article/${article.slug}`}>
    <div className={article.heroImage !== null ? `${styles.articleCard} article-card` : `article-card no-image ${styles.articleCard}`}>
      <div className={`${styles.cardImage}`}>
        { article.heroImage !== null ? (
            <Img alt={article.title} sizes={article.heroImage.sizes} className={styles.cardImage} />
            ) : (
              <span>&nbsp;</span>
            )
        }
      </div>
      <div className={styles.cardInfo}>
        <h3 className={`${styles.articleCardTitle} card-title`}>{article.title}</h3>
        <div className={styles.cardExcerpt}>{article.excerpt}</div>
        <div className={`${styles.cardAction} card-action`}><FontAwesomeIcon icon={faArrowRight} /></div>
      </div>
    </div>
  </Link>
)


// <Img alt={article.title} sizes={article.heroImage.sizes} className={styles.cardImage} />
        // <div className={styles.cardDate}><small >{article.publishDate}</small></div>


// WEBPACK FOOTER //
// ./src/components/article-preview.js